import { render, staticRenderFns } from "./plus-circle.vue?vue&type=template&id=4c8e1472"
import script from "./plus-circle.vue?vue&type=script&lang=js"
export * from "./plus-circle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports